import { ChangeDetectionStrategy, ChangeDetectorRef, Component, OnDestroy, OnInit } from '@angular/core';
import { DatasetListingService } from 'src/app/dataset-listing/dataset-listing.service';
import { TreeGeneratorService } from 'src/app/core/datasets/tree-generator.service';
import { Category } from '@models/mood/covariates/category';
import { Subscription } from 'rxjs';
import { GroupedTreeNode } from 'src/app/core/datasets/tree.interface';
import { v4 } from 'uuid';
import { AdminService } from '../../admin/admin.service';
import { ActivatedRoute, Router } from '@angular/router';
import { TopBarService } from 'src/app/top-bar/top-bar.service';

@Component({
  selector: 'mood-category-admin',
  templateUrl: './categories.component.html',
  styleUrls: ['categories.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class CategoryAdminComponent implements OnInit, OnDestroy {
  categoryList: Category[] = [];
  categoryTreeList: GroupedTreeNode[] = [];

  selectedCategory?: Category;

  private _categoryChangeSubscription?: Subscription;

  constructor(
    private _dataListService: DatasetListingService,
    private _treeGenerator: TreeGeneratorService,
    private _adminService: AdminService,
    private _activatedRoute: ActivatedRoute,
    private _router: Router,
    private _changeDetector: ChangeDetectorRef,
    private _topBarService: TopBarService
  )
  {
    this._topBarService.setTitle('Covariate Categories');
  }

  ngOnDestroy(): void {
    this._categoryChangeSubscription?.unsubscribe();
  }

  addNewCategory() {
    this._router.navigate(
      [],
      {
        relativeTo: this._activatedRoute,
        queryParams: {
          id: v4()
        }
      }
    );
  }

  async ngOnInit() {
    await this._generateTree();

    this._categoryChangeSubscription = this._adminService.changeSelectedCategory.subscribe(result => {
      this._router.navigate(
        [],
        {
          relativeTo: this._activatedRoute,
          queryParams: {
            id: result
          }
        }
      );
    })

    this._adminService.categoryUpdated.subscribe(async _ => {
      await this._generateTree();
    });

    this._activatedRoute.queryParams.subscribe(params => {
      this.doCategorySelected(params['id'])!;

      if (!this.selectedCategory) {
        this.selectedCategory = {
          id: params['id']
        } as Category;
      }
      this._changeDetector.markForCheck();
    });
  }

  private async _generateTree() {
    this.categoryList = await this._dataListService.getDatasetCategories();

    this.categoryTreeList = this._treeGenerator.createCategoryTree(this.categoryList);

    this._changeDetector.markForCheck();
  }

  doCategorySelected(selectedNode: string) {
    this.selectedCategory = this.categoryList.find(category => category.  id === selectedNode)
  }
}
